"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThisSelectionUnitEnum = exports.SortConfigDirectionEnum = exports.PreviousSelectionUnitEnum = exports.LastSelectionUnitEnum = exports.DateRangeSlicerGranularityEnum = exports.ChartUserOverridesDataLabelsEnum = exports.ChartUserOverridesLegendPositionEnum = exports.ChartUserOverridesStackingEnum = exports.ChartUserOverridesChartTypeEnum = exports.ChartBlockChartTypeEnum = exports.AIInsightsBlockGradientDirectionEnum = void 0;
exports.AIInsightsBlockGradientDirectionEnum = {
    R: 'to-r',
    Br: 'to-br',
    Bl: 'to-bl',
    Tr: 'to-tr',
    L: 'to-l',
    Tl: 'to-tl'
};
exports.ChartBlockChartTypeEnum = {
    Line: 'line',
    Bar: 'bar',
    HorizontalBar: 'horizontalBar',
    Pie: 'pie',
    Doughnut: 'doughnut',
    Scatter: 'scatter',
    Bubble: 'bubble',
    Area: 'area',
    Funnel: 'funnel',
    Treemap: 'treemap',
    Sankey: 'sankey',
    Heatmap: 'heatmap',
    Waterfall: 'waterfall',
    Bridge: 'bridge',
    Gantt: 'gantt',
    Choropleth: 'choropleth',
    BubbleMap: 'bubbleMap'
};
exports.ChartUserOverridesChartTypeEnum = {
    Bar: 'bar',
    HorizontalBar: 'horizontalBar',
    Line: 'line',
    Area: 'area',
    Pie: 'pie',
    Doughnut: 'doughnut',
    Funnel: 'funnel'
};
exports.ChartUserOverridesStackingEnum = {
    None: 'none',
    Stacked: 'stacked',
    Percent: 'percent'
};
exports.ChartUserOverridesLegendPositionEnum = {
    None: 'none',
    Top: 'top',
    Bottom: 'bottom',
    Left: 'left',
    Right: 'right'
};
exports.ChartUserOverridesDataLabelsEnum = {
    None: 'none',
    Inside: 'inside',
    Outside: 'outside'
};
exports.DateRangeSlicerGranularityEnum = {
    Day: 'day',
    Month: 'month',
    Year: 'year'
};
exports.LastSelectionUnitEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year'
};
exports.PreviousSelectionUnitEnum = {
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year'
};
exports.SortConfigDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
};
exports.ThisSelectionUnitEnum = {
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year'
};
